import { createContext, useContext, useState } from "react";

const AssistantContext = createContext({ context: null, setContext: () => {} });

export function AssistantProvider({ children }) {
  const [context, setContext] = useState(null);
  return <AssistantContext.Provider value={{ context, setContext }}>{children}</AssistantContext.Provider>;
}

export const useAssistantContext = () => useContext(AssistantContext);
